import React from "react";
import { Link } from "react-router-dom";
import {FaBed, FaBath} from 'react-icons/fa'

const ListingItems = ({ listing, id, onDelete, onEdit  }) => {
  return (
    <>
      <div className="d-flex align-items-center justify-content-center mb-4">
        <div className="card category-link shadow-sm hehe" style={{ width: "900px" }}>
          <Link to={`/category/${listing.type}/${id}`} >
            <div className="row container p-2">
              <div className="col-md-5 col-5">
                <img
                  src={listing.imgUrls[0]}
                  alt={listing.name}
                  height={200}
                  width={300}
                  className="img-thumbnail"
                />
              </div>
              <div className="col-md-5 col">
                <p>{listing.location}</p>
                <h2>{listing.name}</h2>
                <p>Rs : {listing.offer ? listing.offerPrice : listing.regularPrice}/-
                {listing.type === 'rent' && ' Per Month'}
                {listing.type === 'lease' && ' for 5 years'}</p>
                <p><FaBed/> &nbsp;{listing.bedrooms > 1 ? `${listing.bedrooms} Bedrooms` : '1 Bedroom'}</p>
                <p><FaBath/> &nbsp;{listing.bathrooms > 1 ? `${listing.bathrooms} Bathrooms` : '1 Bathroom'}</p>
                {!onDelete && listing.offer && (
                    <p className="offpri">On Offer</p>
                )}
              </div>
            </div>
          </Link>
          <div className="d-flex justify-content-center align-items-center mb-2">
          {onDelete && (
                  <button className="btn btn-danger " onClick={()=> {onDelete(id)}} >Delete Listing</button>
                )}
          {onEdit && (
                  <button className="btn btn-dark text-white ms-3" onClick={()=> {onEdit(id)}} >Edit Listing</button>
                )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ListingItems;
